"use client";

import MyMoneyCustomerComponent from "@/features/customer-information/components/my-money-customer";
import { renderByProcess } from "@/shared/render-by-process";
import CreditCustomerComponent from "./components/credit-customer";
import LoanCustomerComponent from "./components/loan-customer";
import {
	CreditCardCustomerInformationContext,
	CustomerInformationContext,
	LoanCustomerInformationContext,
	MyMoneyCustomerInformationContext,
} from "./types";

interface Props {
	taskId: string;
	context: CustomerInformationContext;
}

const CustomerInformationPage = ({ taskId, context }: Props) => {
	return renderByProcess<
		LoanCustomerInformationContext,
		CreditCardCustomerInformationContext,
		MyMoneyCustomerInformationContext
	>(context, {
		loan: (context) => <LoanCustomerComponent {...{ context, taskId }} />,
		credit: (context) => <CreditCustomerComponent {...{ context, taskId }} />,
		myMoney: (context) => <MyMoneyCustomerComponent {...{ context, taskId }} />,
	});
};

export default CustomerInformationPage;
